import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

import billRoutes from "./modules/billRoutes";
import endoscopeRoutes from "./modules/endoscopeRoutes";

const routes = [
  // {
  //     path:'/',
  //     name:'getCodePage',
  //     component:() => import('../pages/GetCodePage.vue')
  // },
  {
    path: '/',
    name: 'startPage',
    component: () => import("../pages/StartPage.vue"),
  },
  // {
  //     path: "/",
  //     name: "home",
  //     component: () => import("../pages/Home.vue"),
  // },
  {
    path: "/report",
    name: "report",
    component: () => import("../pages/Report.vue"),
  },
  {
    path: "/result",
    name: "result",
    // component: () => import("../pages/Result.vue"),
    component: () => import("../pages/ResultCopy.vue"),
  },
  {
    path: "/recommend",
    name: "recommend",
    component: () => import("../pages/Recommend.vue"),
  },
  {
    path: "/order-preview",
    name: "orderPreview",
    component: () => import("../pages/OrderPreview.vue"),
  },
  {
    path: "/submit-info",
    name: "submitInfo",
    component: () => import("../pages/SubmitInfo.vue"),
  },
  {
    path: "/create-patient",
    name: "createPatient",
    component: () => import("../pages/CreatePatient.vue"),
  },
  {
    path: "/patient-list",
    name: "patientList",
    component: () => import("../pages/PatientList.vue"),
  },
  {
    path: "/order-list",
    name: "orderList",
    component: () => import("../pages/OrderList.vue"),
  },
  // 在微信端查看报告
  {
    path: '/checkReport',
    name: 'checkReport',
    component: () => import("../pages/check-query/CheckQuery.vue"),
  },
  {
    path: '/reportList',
    name: 'reportList',
    component: () => import("../pages/check-report/ReportList.vue"),
  },
  {
    path: '/reportInfo',
    name: 'reportInfo',
    component: () => import("../pages/check-report/ReportInfo.vue"),
  },
  {
    path: '/critical-from',
    name: 'critical-from',
    component: () => import("../pages/critical-from/critical-from.vue"),
  },
  {
    path: '/critical-save',
    name: 'critical-save',
    component: () => import("../pages/critical-from/critical-save.vue"),
  },
  {
    path: '/critical-record',
    name: 'critical-record',
    component: () => import("../pages/critical-record/critical-record.vue"),
  },
  {
    path: '/critical-info',
    name: 'critical-info',
    component: () => import("../pages/critical-record/critical-info.vue"),
  },
  {
    path: '/handle-record',
    name: 'handle-record',
    component: () => import("../pages/critical-record/handle-record.vue"),
  },
  {
    path: '/handle-info',
    name: 'handle-info',
    component: () => import("../pages/critical-record/handle-info.vue"),
  },
  {
    path: '/receive-record',
    name: 'receive-record',
    component: () => import("../pages/critical-record/receive-record.vue"),
  },
  {
    path: '/receive-info',
    name: 'receive-info',
    component: () => import("../pages/critical-record/receive-info.vue"),
  },
  {
    path: '/consult',
    name: 'consult',
    component: () => import("../pages/Consult.vue"),
  },
  {
    path: '/check-query',
    name: 'check-query',
    component: () => import("../pages/check-query/CheckQuery.vue")
  },
  {
    path: '/check-query-list',
    name: 'check-query-list',
    component: () => import("../pages/check-query/CheckQueryList.vue")
  },
  {
    path: '/check-query-pdf',
    name: 'check-query-pdf',
    component: () => import("../pages/check-query/CheckQueryPdf.vue")
  },
  {
    path: '/check-query-report-list',
    name: 'check-query-report-list',
    component: () => import("../pages/check-query/CheckQueryReportList.vue")
  },
  {
    path: '/CheckDetailsPage',
    name: 'CheckDetailsPage',
    component: () => import("../pages/check-query/CheckDetailsPage.vue"),
  },
  {
    path: '/CheckTime',
    name: 'CheckTime',
    component: () => import("../pages/check-query/CheckTime.vue"),
  },
  {
    path: '/reportInfoData',
    name: 'reportInfoData',
    component: () => import("../pages/check-query/ReportInfoData.vue"),
  },
  {
    path: '/downloadOriginal',
    name: 'downloadOriginal',
    component: () => import("../pages/check-query/downloadOriginal.vue"),
  },
  //图像报告
  {
    path: '/reportInfoDataCopy',
    name: 'reportInfoDataCopy',
    component: () => import("../pages/check-query/ReportInfoDataCopy.vue"),
  },
  // 解密链接
  {
    path: '/reportEncryption',
    name: 'reportEncryption',
    component: () => import("../pages/check-query/reportEncryption.vue"),
  },
  // 分享链接
  {
    path: '/shareLinks',
    name: 'shareLinks',
    component: () => import("../pages/shareLinks.vue"),
  },
  // 早筛长报告查看
  {
    path: '/check-report-view',
    name: 'checkReportView',
    component: () => import("../pages/check-report-view/index.vue"),
  },
  {
    path: '/customerBudgetSheet',
    name: 'customerBudgetSheet',
    component: () => import("../pages/customerBudgetSheet/index.vue"),
  },
  // 团检预约-个人信息
  {
    path: '/team-check-order',
    name: 'teamCheckOrder',
    component: () => import("../pages/teamCheckOrder/index.vue"),
  },
  {
    path: '/ihealth-scheduling-calendar',
    name: 'ScheduleCalendar',
    component: () => import("../pages/schedule/ScheduleCalendar.vue")
  },
  {
    path: '/ihealth-scheduling-detail',
    name: 'ScheduleDetail',
    component: () => import("../pages/schedule/ScheduleDetail.vue")
  },
  {
    path: '/ihealth-scheduling-form',
    name: 'ScheduleForm',
    component: () => import("../pages/schedule/ScheduleForm.vue")
  },
  {
    path: '/ihealth-scheduling-editForm/:id',
    name: 'ScheduleEdit',
    component: () => import("../pages/schedule/ScheduleForm.vue")
  },
  {
    path: '/ihealth-scheduling-login',
    name: 'ScheduleLogin',
    component: () => import("../pages/schedule/Login.vue")
  },


  ...billRoutes,
  ...endoscopeRoutes,
];

const router = new VueRouter({
  routes,
  mode: 'history',
  scrollBehavior(to, from, saveTop) {
    if (saveTop) {
      return saveTop;
    } else {
      return {
        x: 0,
        y: 0
      };
    }
  },
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js